export const uiCookiePreferences = {
    name: 'UI Cookie Preferences',
    description: '',
    displayField: 'heading',
    fields: {
        heading: {
            name: 'Heading',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        requiredCookiesHeading: {
            name: 'Required Cookies Heading',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        requiredCookiesBody: {
            name: 'Required Cookies Body',
            type: 'Text',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        optionalCookiesHeading: {
            name: 'Optional Cookies Heading',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        optionalCookiesBody: {
            name: 'Optional Cookies Body',
            type: 'Text',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        preferencesButtonText: {
            name: 'Preferences Button Text',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        }
    }
};
//# sourceMappingURL=uiCookiePreferences.js.map